import Modal from "@/components/base/Modal";
import { QRCodeCanvas } from "qrcode.react";

interface QrYoklamaModalProps {
  open: boolean;
  onClose: () => void;
  roomCode: string;
  className?: string;
}

export default function QrYoklamaModal({ open, onClose, roomCode, className = "" }: QrYoklamaModalProps) {
  const basePath = __BASE_PATH__.split("/").filter(Boolean).join("/");
  const pathPrefix = basePath ? `/${basePath}` : "";
  const url = `${window.location.origin}${pathPrefix}/ogrenci/yoklama?code=${encodeURIComponent(roomCode)}`;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="QR ile Yoklama"
      titleId="qr-yoklama-title"
      id="qr-yoklama-modal"
      maxWidthClass="max-w-sm"
    >
      <div className="space-y-4 flex flex-col items-center text-center">
        {className && (
          <p className="text-sm text-foreground-600">
            <span className="font-semibold text-foreground-900">{className}</span> dersi için öğrenciler bu QR kodu
            telefonlarıyla okutup derse katılımlarını otomatik işaretler.
          </p>
        )}
        <div className="p-4 rounded-lg border border-background-200 bg-white">
          <QRCodeCanvas value={url} size={208} level="M" includeMargin />
        </div>
        <div className="text-sm font-semibold text-foreground-800">
          Oda Kodu: <span className="text-primary-700">{roomCode}</span>
        </div>
        <p className="text-[11px] text-foreground-400 break-all px-2">{url}</p>
      </div>
    </Modal>
  );
}